// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"0a60b988","275":"fa3ab8fb","352":"84a20bdf","676":"962948d1","701":"01c6a70d","783":"b59d8f07"}[chunkId] + ".chunk.js";
};